import { useEffect, useState } from "react";
import { invoicePermissionsService } from "../services/invoicePermissionsService";

export const useNetInvoicePermission = (fileType = "net") => {
  const [hasPermission, setHasPermission] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkPermission = async () => {
      try {
        setLoading(true);
        const result = await invoicePermissionsService.hasPermission(fileType);
        setHasPermission(result.hasPermission);
        setError(null);
      } catch (err) {
        if (err.response?.status === 403) {
          setHasPermission(false);
          setError("No permission");
        } else {
          setError(err);
        }
      } finally {
        setLoading(false);
      }
    };

    checkPermission();
  }, [fileType]);

  return { hasPermission, loading, error };
};
